import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../data/comparison';
import { Eyebrow } from './Eyebrow';
export function Problems() {
  return <section aria-labelledby="problems-heading" className="bg-paper-100 py-16 sm:py-24" data-id="element-204" data-mp="36y3qtsjv9yer">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-205" data-mp="322y6gy644rss">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,22rem)_minmax(0,1fr)] lg:gap-20" data-id="element-206" data-mp="2y2eahxx9zu88">
          <div data-id="element-207" data-mp="2t4mil3wms841">
            <Eyebrow data-id="element-208" data-mp="2t55rjv4azm5x">The reality of jazz teaching</Eyebrow>
            <h2 id="problems-heading" className="mt-5 font-display text-3xl leading-tight text-ink sm:text-4xl" data-id="element-209" data-mp="2o5jdjjgni1w2">
              Teach jazz guitar? These problems sound familiar?
            </h2>
            <p className="mt-6 border-l-2 border-wine pl-5 font-display text-xl italic leading-snug text-wine" data-id="element-210" data-mp="2f5msdrtgzl5r">
              How much longer are you willing to improvise?
            </p>
          </div>

          <ul className="divide-y divide-paper-300" data-id="element-211" data-mp="dejhr2jky6l7">
            {problems.map(problem => <li key={problem} className="flex items-start gap-4 py-5 first:pt-0 last:pb-0" data-id="element-212" data-mp="34q3gfz3l835t">
                <XIcon className="mt-0.5 h-5 w-5 shrink-0 text-wine" aria-hidden="true" data-id="element-213" data-mp="39qzlifzodvct" />
                <span className="text-base leading-relaxed text-ink-soft" data-id="element-214" data-mp="2vqyeeisthrow">{problem}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}